var _rect, _rect2, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSheet = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 78,
    viewBox: "0 0 75 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49.4545,
    height: 61.7273,
    fill: "#F6F0EB",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7725,
    y: 15.5,
    width: 49.4545,
    height: 61.7273,
    fill: "#FBF6F2",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.7278,
    cy: 47,
    r: 11.7727,
    fill: "#FBF6F2",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2732 47.0001H67.5005",
    stroke: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSheet);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzgiIHZpZXdCb3g9IjAgMCA3NSA3OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSI0OS40NTQ1IiBoZWlnaHQ9IjYxLjcyNzMiIGZpbGw9IiNGNkYwRUIiIHN0cm9rZT0iYmxhY2siLz4KPHJlY3QgeD0iMTIuNzcyNSIgeT0iMTUuNSIgd2lkdGg9IjQ5LjQ1NDUiIGhlaWdodD0iNjEuNzI3MyIgZmlsbD0iI0ZCRjZGMiIgc3Ryb2tlPSJibGFjayIvPgo8Y2lyY2xlIGN4PSI2Mi43Mjc4IiBjeT0iNDciIHI9IjExLjc3MjciIGZpbGw9IiNGQkY2RjIiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZD0iTTU3LjI3MzIgNDcuMDAwMUg2Ny41MDA1IiBzdHJva2U9ImJsYWNrIi8+Cjwvc3ZnPgo=";